var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value && _vm.value.length)?_c('div',{staticClass:"trusted"},[_vm._t("default",function(){return [_c('v-runtime-template',{attrs:{"template":_vm.withMedia}})]},{"value":_vm.value})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }